import React from 'react'
import {Col, Row} from 'react-bootstrap'

import {InputWithLabel} from '../../../../component/Form/InputWithLabel'
import ProductTypeSelector, { mapItems } from '../../../../productType/component/ProductTypeSelector'
import BizLocationSelector from '../../../../component/BizLocation/BizLocationSelector'

function CriticalLevelStockForm({defaultValue = {}, setValue}) {

  return (
    <Row>
      <Col md={6}>
        <BizLocationSelector
          setValue={e => setValue({
            bizLocations: e
          })}
          multiple
          defaultValue={defaultValue.bizLocations}
        />
      </Col>
      <Col md={6}>
        <ProductTypeSelector
          setValue={e => {
            setValue({
              productTypes: e
            })
          }}
          multiple
          defaultValue={defaultValue.productTypes && defaultValue.productTypes.map(mapItems)}
        />
      </Col>
      <Col md={6}>
        <InputWithLabel
          label="Porcentagem minima do estoque"
          inputType="number"
          onChange={e => setValue({...defaultValue, minValue: e.target.value})}
          defaultValue={defaultValue.minValue}
          required
          min={1}
        />
      </Col>
      <Col md={6}>
        <InputWithLabel
          label="Porcentagem máxima do estoque"
          inputType="number"
          onChange={e => setValue({...defaultValue, maxValue: e.target.value})}
          defaultValue={defaultValue.maxValue}
        />
      </Col>
    </Row>
  )
}

export {CriticalLevelStockForm}



// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/StockLevelAlert/CriticalLevelStockForm.js